<div class="chepfm--form__collapse-contain">
    <div class="row">
        <div class="col-xs-4">
            <div class="data-filter">
                <label class="view-data" [i18n]="'df-management.df-admin.form.country-code'"></label>
                <div class="chepfm--form__collapse-heading">
                {{countryData['country_code']}}
            </div>
            </div>
        </div>
        <div class="col-xs-4">
            <div class="data-filter">
                <label class="view-data" [i18n]="'df-management.df-admin.form.country-name'"></label>
                <div class="chepfm--form__collapse-heading">
               {{countryData.country}}
            </div>
            </div>
        </div>
        <div class="col-xs-4">
            <div class="data-filter">
                <label class="view-data" [i18n]="'df-management.df-admin.form.time-zone'"></label>
                <div class="chepfm--form__collapse-heading">
                {{countryData['timezone']}}
            </div>
            </div>
        </div>
    </div>
    <hr *ngIf="isCalendarEnabled" />
    <h4 *ngIf="isCalendarEnabled" class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.calendar-details'"></h4>
    <div *ngIf="isCalendarEnabled" class="row">
        <div class="col-xs-4">
            <div class="data-filter">
            <div>
                <button class="add-new-year-button btn btn-i btn-primary" (click)="addNewYear()" [i18n]="'df-management.df-admin.calendar.addCalendar'"></button>  
            </div>
            </div>
        </div>
    </div>

    <hr />
    <h4 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.schedulers-title'"></h4>
    &nbsp;
    <div class="row">
        <div class="col-xs-4">
            <div class="data-filter">
            <div>
                <span [ngClass]="{'chepfm--badge chepfm--badge__danger': (countryData['scheduler_flag'] === false ), 'chepfm--badge chepfm--badge__success': (countryData['scheduler_flag'] === true) }">
               {{countryData['scheduler_flag']  ? 'Active' : 'Inactive'}}
               </span>
            </div>
            </div>
        </div>
    </div>
    <hr />
    
    &nbsp;
    <div class="row">
        <div class="col-xs-4">
            <div class="data-filter">
            <h4 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.fixed-charges-title'"></h4>
            <div>
                <span>
               {{countryData['country_job_frequency_details']['fixed_charge_frequency'] || '-'}}
               </span>
            </div>
            </div>
        </div>
        <div class="col-xs-4">
            <div class="data-filter">
        <h4 class="chepfm--form__collapse-heading" [i18n]="'df-management.df-admin.form.voucher-charge'"></h4>
            <div>
                <span>
               {{countryData['country_job_frequency_details']['initial_voucher_charge'] || '1'}}
               </span>
            </div>
            </div>
        </div>
    </div>
</div>


<div id="customFrequencyModal" class="modal" [ngClass]="{'show': isModalOpen}">
    <div class="modal-content">
      <img class="crossIcon" src="/assets/crossIcon.svg" (click)="closeModal()">
      <span class="yearTitle" [i18n]="'df-management.form.model-popup.selectYear'"></span>
      <div>
        
        <div class="data-filter yearSelection">
            <label class="startYear" [i18n]="'df-management.form.model-popup.startYear'"></label>
            <ng-select [(ngModel)]="selectedYear">
                <ng-option *ngFor="let year of years" [value]="year">{{ year }}</ng-option>
              </ng-select>
        </div>
      </div>
      <div class="form-group">
        <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="calendarDatesNavigation()"
        [i18n]="'df-management.df-admin.form.submit-button'">
        </button>
    </div>
    </div>
  </div>
